
    import __i18nConfig from '@next-translate-root/i18n.json'
    import __loadNamespaces from 'next-translate/loadNamespaces'
    import type { GetStaticPaths, GetStaticProps } from 'next';
import InteriorLanding, { type InteriorLandingProps, } from '@/components/interior-landing/InteriorLanding';
import { getRoomPageProps, interiorRoomSlugs, } from '@/components/interior-landing/server';
export default function AiRoomDesignPage(props: InteriorLandingProps) {
    return <InteriorLanding {...props}/>;
}
const getStaticProps: GetStaticProps<InteriorLandingProps> = async ({ params, locale, }) => {
    const props = await getRoomPageProps(String(params?.room ?? ''), locale);
    if (!props)
        return { notFound: true };
    return { props };
};
// Every language: the pages' hreflang lists all of them.
export const getStaticPaths: GetStaticPaths = async ({ locales = ['en'] }) => ({
    paths: interiorRoomSlugs().flatMap((room) => locales.map((locale) => ({ params: { room }, locale }))),
    fallback: false,
});

    async function __Next_Translate__getStaticProps__1a167d9f152__(ctx) {
      if (typeof global !== 'undefined') {
        global.i18nConfig = __i18nConfig
      }
      const res = await getStaticProps(ctx)
      return {
        
        ...res,
        props: {
          ...(res.props || {}),
          ...(await __loadNamespaces({
            ...ctx,
            ...__i18nConfig,
            pathname: '/ai-interior-design-generator/[room]/index',
            loaderName: 'getStaticProps',
            loadLocaleFrom: __i18nConfig && __i18nConfig.loadLocaleFrom || ((l, n) => import('../../../../locales/' + l + '/' + n).then(m => m.default)),
          }))
        }
      }
    }
    export { __Next_Translate__getStaticProps__1a167d9f152__ as getStaticProps }
  